import { AsyncStorage } from '@betty/toolkit/storage';
import {
  appLogout,
  persistReducer,
  createAsyncThunk,
  createSlice,
  createSelector,
  injectSlice,
} from '@betty/toolkit/state';
import { PromotedContentState } from './promotedContent.types';
import PromotedContentService from '../../services/PromotedContentService/PromotedContentService';

export const fetchPromotedContent = createAsyncThunk(
  'promotedContent/fetch',
  async () => await PromotedContentService.getPromotedContent(),
);

const initialState: PromotedContentState = {
  promotedContent: undefined,
  promotedContentDataState: 'idle',
};

const promotedContent = createSlice({
  name: 'promotedContent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPromotedContent.fulfilled, (state, action) => {
      const { promotedContent } = action.payload;
      state.promotedContent = promotedContent;
      state.promotedContentDataState = 'fulfilled';
    });

    builder.addCase(fetchPromotedContent.pending, (state) => {
      state.promotedContentDataState = 'pending';
    });

    builder.addCase(fetchPromotedContent.rejected, (state) => {
      state.promotedContentDataState = 'rejected';
    });

    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

const persistConfig = {
  key: 'promotedContent',
  storage: AsyncStorage,
};

const persistedReducer = persistReducer(persistConfig, promotedContent.reducer);

export const withPromotedContent = injectSlice({
  reducerPath: 'promotedContent',
  reducer: persistedReducer,
});

export const selectPromotedContent = withPromotedContent.selector(
  (state) => state.promotedContent.promotedContent,
);

export const selectPromotedGameIds = createSelector(
  [selectPromotedContent],
  (content) => content?.find((item) => item.type === 'Games')?.itemIds || [],
);

export const selectPromotedSubproviderIds = createSelector(
  [selectPromotedContent],
  (content) =>
    content?.find((item) => item.type === 'Subproviders')?.itemIds || [],
);

export const selectPromotedContentDataState = withPromotedContent.selector(
  (state) => state.promotedContent.promotedContentDataState,
);

declare global {
  interface LazyLoadedSlices {
    promotedContent: ReturnType<typeof persistedReducer>;
  }
}
